import React, { FC, useState } from 'react';
import { Box, Tab, Tabs, Typography } from '@mui/material';
import Container from '@/components/Container';
import { PageStatusTestView } from '@/components/Admin/AdminTestTools/PageStatus/PageStatusTestView';

export const AdminTestToolsView: FC = () => {
  const [useTab, setUseTab] = useState(0);

  return (
    <Container left fullWidth p={2} top mt={0} column sx={{ maxWidth: '100%', minWidth: 0, overflowX: 'hidden' }}>
      <Typography variant='h3' sx={{ fontSize: { xs: 18, sm: 20 } }}>
        Testverktøy
      </Typography>

      <Tabs
        value={useTab}
        onChange={(_, newValue) => setUseTab(newValue)}
        textColor='secondary'
        variant='scrollable'
        scrollButtons='auto'
        allowScrollButtonsMobile
        slotProps={{
          indicator: {
            style: {
              background: 'black',
            },
          },
        }}
        sx={{
          mb: 2,
          maxWidth: '100%',
          '& .MuiTabs-scroller': {
            overflowX: 'auto !important',
          },
        }}>
        <Tab label='Sidestatus' value={0} onClick={() => setUseTab(0)} />
        <Tab label='Testverktøy 2' value={1} onClick={() => setUseTab(1)} />
      </Tabs>

      <Box
        role='tabpanel'
        hidden={useTab !== 0}
        aria-hidden={useTab !== 0}
        sx={{
          display: useTab === 0 ? 'block' : 'none',
          width: '100%',
          maxWidth: '100%',
          minWidth: 0,
          overflowX: 'hidden',
        }}>
        <PageStatusTestView />
      </Box>

      <Box
        role='tabpanel'
        hidden={useTab !== 1}
        aria-hidden={useTab !== 1}
        sx={{
          display: useTab === 1 ? 'block' : 'none',
          width: '100%',
          maxWidth: '100%',
          minWidth: 0,
          overflowX: 'hidden',
        }}>
        <Container>
          <Typography>Innhold for Testverktøy 2</Typography>
          {/* Add test tool 2 content here */}
        </Container>
      </Box>
    </Container>
  );
};

export default AdminTestToolsView;
